// Landing-Page für /trips (und /), wenn kein Slug in der URL steht.
// Listet alle existierenden Trips aus dem trips:index in KV.
//
// Wird vom main-trip-Entry direkt gerendert, nicht über den React-Router —
// der Router läuft mit `basename: /trips/<slug>`, was ohne Slug nicht geht.
// Klick auf eine Card macht einen Hard-Navigate via <a href>, damit der
// Router mit dem neuen Slug frisch bootstrappt.

import { useTripList } from '@/hooks/useTripList';
import { tripBasename } from '@/lib/env';
import styles from './TripListPage.module.css';

export default function TripListPage() {
  const query = useTripList();

  return (
    <div className="app-shell">
      <h1 className={styles.heading}>mallorca-trips</h1>
      <p className={styles.intro}>Wähle einen Trip aus.</p>

      {query.isLoading ? (
        <div className="loading">Lade Trips …</div>
      ) : query.isError ? (
        <div className={styles.errorState}>
          Trips konnten nicht geladen werden.
          <div>
            <button type="button" onClick={() => query.refetch()}>Erneut versuchen</button>
          </div>
        </div>
      ) : (query.data ?? []).length === 0 ? (
        <p className={styles.emptyState}>
          Noch kein Trip vorhanden. Bitte rufe einen Trip-Link auf, z.B.{' '}
          <code>/trips/mai-2026/</code>.
        </p>
      ) : (
        <ul className={styles.list} style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {(query.data ?? []).map((t) => (
            <li key={t.slug}>
              <a href={`${tripBasename(t.slug)}/`} className={styles.tripCard}>
                <div className={styles.tripHeader}>{t.header || t.slug}</div>
                {t.dateBadge ? <div className={styles.tripBadge}>{t.dateBadge}</div> : null}
                {t.subtitle ? <div className={styles.tripSubtitle}>{t.subtitle}</div> : null}
                <div className={styles.tripSlug}>/{t.slug}</div>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
